export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const BADGE = {
  bestseller: { label: "Bestseller", color: "#e2ff00", glow: "rgba(226,255,0,0.30)" },
  legendary: { label: "Legendary", color: "#f59e0b", glow: "rgba(245,158,11,0.32)" },
  limited: { label: "Limited", color: "#ff0055", glow: "rgba(255,0,85,0.32)" },
  premium: { label: "Premium", color: "#a855f7", glow: "rgba(168,85,247,0.32)" },
};

export const FILTERS = [
  { key: "alle", label: "Alle" },
  { key: "bestseller", label: "Bestseller" },
  { key: "limited", label: "Limited" },
  { key: "premium", label: "Premium" },
  { key: "legendary", label: "Legendary" },
  { key: "sale", label: "Sale" },
];

export const fmtPrice = (n) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n);

export const imgUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/api")) return `${BACKEND_URL}${src}`;
  return src; // frontend public asset like /products/x.jpg
};
